import { createGlobalState } from 'react-hooks-global-state';

// Status badge shown next to a popup pager (Reference claim / superscript).
type NavStatus = {
  label: string;
  help: string;
  color: string;
  bg: string;
  border: string;
} | null;

const { setGlobalState, useGlobalState } = createGlobalState({
  reload: true,
  modaltype: null,
  modalmessage: null,
  sessionerror: null,
  loggedin: false,
  charts1: true,
  charts2: true,
  extractdoc: null,
  exportdoc: true,
  caseName: '',
  resultcase: null,
  resultdoc: null,
  resultfile: null,
  resultfilename: null,
  resultshow: false,
  resultreload: true,
  PIIKeyword: null,
  PIIKeywordstatus: false,
  esearch: null,
  PIICase: null,
  FileExplorer: false,
  ReviewTools: false,
  PIItag: null,
  PIIstartoffsets: null,
  PIIendoffsets: null,
  PIItagcolor: null,
  PIIcontent: null,
  PIIOldTag: null,
  SavePIIs: false,
  ResetPIIs: false,
  DeletePIIs: false,
  AllPIITags: null,
  ReviewEmbedType: null,
  ReviewFolderID: null,
  SearchParams: null,
  SearchReload: false,
  SearchType: 1,
  SearchBarWidth: '60px',
  AdvanceQuery: {},
  ShowCoding: true,
  UpdatePIIS: false,
  CloseModal: false,
  relationTag: null,
  relationStart: null,
  relationEnd: null,
  relationRow: null,
  tagRow: null,
  relationtext: null,
  relationselected: false,
  relationLabel: null,
  RelationPIIs: null,
  RelationPIIsDefault: null,
  PIICounter: 0,
  RemoveRelation: false,
  OriginalRelation: null,
  OriginalText: null,
  UploadedPIIids: '',
  UploadedPIICount: 0,
  DownloadPIIs: false,
  ExportPIIs: false,
  PIIReviewer: false,
  modelType: 1,
  AdditionalPIIRow: null,
  AdditionalPIITag: null,
  AdditionalPIIText: null,
  AdditionalPIIstart: null,
  AdditionalPIIend: null,
  removeStart: null,
  removeEnd: null,
  removeRow: null,
  removeText: null,
  removeTag: null,
  removeCount: null,
  TagginArray: null,
  PIIColors: null,
  rerelation: null,
  DeleteCase: true,
  Config: null,
  BucketType: null,
  BucketPath: null,
  BucketRegion: null,
  ErrorFoundGlobal: true,
  improvementFounds: 0,
  issueLine: 1,
  issueSelect: false,
  BrandsFounds: 0,
  BrandsLine: 1,
  BrandsSelect: false,
  AllLine: 1,
  AllSelect: false,
  AllSelectISI: false,
  // Claims tab navigation shared with the PDF full-width popup:
  // ClaimNav is published by Views/All/sidebarRight (current/total claim),
  // ClaimNavRequest is bumped by the popup's prev/next buttons (dir -1 | 1)
  // or its claim-number box (to = 1-based claim number, 0 = not a jump).
  ClaimNav: { current: 0, total: 0 },
  ClaimNavRequest: { dir: 0, nonce: 0, to: 0 },
  // Same pair for the Reference tab, published by Views/All/SidebarRightReference.
  RefClaimNav: { current: 0, total: 0, canLocate: false, status: null as NavStatus },
  RefClaimNavRequest: { dir: 0, nonce: 0, to: 0 },
  // Superscript (reference/footnote) pager of the active reference claim.
  RefDetailNav: { current: 0, total: 0, label: '', canLocate: false, status: null as NavStatus },
  RefDetailNavRequest: { dir: 0, nonce: 0, to: 0 },
  // Occurrence pager of the active claim when it appears in several places in
  // the PDF (rows with `highlight_claims`). ClaimOccNav is published by the
  // Claims panel, RefOccNav by the Reference panel; total 0 = single place.
  ClaimOccNav: { current: 0, total: 0, label: '', canLocate: false, status: null as NavStatus },
  ClaimOccNavRequest: { dir: 0, nonce: 0, to: 0 },
  RefOccNav: { current: 0, total: 0, label: '', canLocate: false, status: null as NavStatus },
  RefOccNavRequest: { dir: 0, nonce: 0, to: 0 },
  // Claims panel -> claims PDF viewer: scroll to occurrence `index` (0-based)
  // of the claim with `parentId`.
  ClaimOccurrenceScroll: { parentId: 0, index: 0, nonce: 0 },
  // Claims PDF viewer -> Claims panel: an occurrence highlight was clicked.
  ClaimOccurrenceClick: { parentId: 0, index: 0, nonce: 0 },
  isiLine: 1,
  // Payload for the last ISI highlight clicked in the copyPaste left editor
  // ({ parentId, at }). index.tsx watches this to open the side-by-side modal.
  isiEditorClick: null as { parentId: number; at: number } | null,
  refLine: 1,
  AllSelectRef: false,
  languageType: 'EnglishCommercial',
  languageArray: [],
  ThumbArray: [],
  openTagModal: 0,
  openTagModalTactics: 0,
  openConfirmTactic: 0,
  processServicesStatus: false,
  processServicesStatus2: false,
  DownloadAllCSV: false,
  DownloadAllStatus: false,
  updateAllTab: false,
  updateClaimsTab: false,
  updateBrandsTab: false,
  updateChineseTab: false,
  ExportRulesStatus: false,
  ExportActivityLogs: false,
  UploadedFiles: [],
  ProcessFile: false,
  RemovecId: 0,
  RemoveHighlight: false,
  processFilesIds: '',
  processFiles: false,
  createServiceFirst: false,
  headerMenu: 0,
  collapse: true,
  expandRows: false,
  rowNumber: 10000000000000000000000000000,
  refreshRowClick: 0,
  HighlightFilenames: '',
  UserHighlight: null,
  UserHighlightUpdate: false,
  NonclickableID: 0,
  ReloadClaims: false,
  DeleteId: 0,
  DeleteHighlight: false,
  rulesArray: [],
  PlusClaim: false,
  DeleteClaim: false,
  DeleteCount: 0,
  Updatesidebar: false,
  UpdatesidebarArray: [],
  Reducesidebar: false,
  ReduceParentId: 0,
  deletedThumbsArray: [],
  stopFile: true,
  getImageId: 0,
  selectedproductType: '',
  claimOptions: [],
  userRoles: [],
  productListingArray: [],
  smartSerachAccessEmails: [],
  refreshQuestionsSidebar: 0,
  cloudStorageVisibility: false,
  LIBRARY_FILE_FILTER_RULES: [],
  minProblematicToShow: 0.7,
  maxProblematicToShow: 0.8
});

export { useGlobalState, setGlobalState };
